var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered-column"},[_c('div',{staticClass:"centered"},[_c('div',{staticClass:"quote",style:(_vm.slide.style)},[_c('i',{staticClass:"icon fas fa-quote-left"}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.slide.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }